import { checkNotifications } from '@/Groups/Notifications/private/api/checkNewNotifications';
import { getNotifications } from '@/Groups/Notifications/private/api/getNotifications';
import { markAllNotificationsAsRead } from '@/Groups/Notifications/private/api/markAllNotifications'; 
import { updateNotifications } from '@/Groups/Notifications/private/api/updateNotifications';

const Notifications = {
  namespaced: true,

  state: {
    list: [],
    avatarList: [],
    currentPage: 1,
    hasNextPage: true,
    loadingNextPage: false,
    isOpenPopup: false,
    isReady: false,
    isListReady: false,
    isLoadingNextPage: false,
    notificationsCount: 0
  },

  actions: {
    // Переключить видимость попапа
    togglePopup({ commit }, status) {
      commit('TOGGLE_VISIBILITY_STATUS', status);
    },
    
    // Добавить аватарки пользователей в список отображаемых
    addAvatarUsers({ commit }, data) {
      commit('ADD_USER_AVATAR_TO_LIST', data);
    },
    
    //Проверить наличие новых уведомлений
    async checkNewNotifications({ commit }) {
      try {
        const response = await checkNotifications();
        const avatars = response.avatar_urls.slice(0, 4);
        commit('ADD_USER_AVATAR_TO_LIST', avatars);
        commit('SET_NOTIFICATIONS_COUNT', response.notifications_count);
        commit('SET_NOTIFICATIONS_READY_FLAG');
        return response;
      } catch (error) {
        console.error('Ошибка при проверке уведомлений:', error);
        throw error;
      }
    },

    //Загрузить уведомления
    async fetchNotifications({ commit, state }, { page = 1, reset = false } = {}){
      try {
        const response = await getNotifications(page);
        if(reset) { commit('RESET_NOTIFICATIONS'); }
        commit('ADD_NOTIFICATIONS', response.results);
        commit('SET_PAGINATION', {
          currentPage: page,
          hasNextPage: !!response.next
        });
        return response;
      } catch (error) {
        console.error('Ошибка при загрузке уведомлений:', error);
        throw error;
      } finally {
        commit('SET_READY_LIST_STATE', true);
      }
    },

    //Загрузить следующую страницу
    async loadNextPage({ dispatch, state, commit }) {
      if (!state.hasNextPage || state.loadingNextPage) return;
      commit('SET_LOADING_NEXT_PAGE_STATE', true);
      const nextPage = state.currentPage + 1;
      await dispatch('fetchNotifications', { page: nextPage });
      commit('SET_LOADING_NEXT_PAGE_STATE', false);
    },

    //Отметить все нотификации как прочитанные
    async markAllAsRead({ state, commit }) {
      try {
        await markAllNotificationsAsRead();
        commit('MARK_ALL_NOTIFICATIONS_AS_READ');
      } catch (error) {
        console.error('Не удалось отметить все уведомления как прочитанные:', error);
      }
    },

    //Отметить как прочитанные только выбранные уведомления
    async markNotificationAsRead({ commit, state }, notificationId) {
      try {
        await updateNotifications([notificationId]);
        commit('MARK_NOTIFICATION_AS_READ', notificationId);
      } catch (error) {
        console.error(`Ошибка при отметке уведомления ${notificationId} как прочитанного:`, error);
      }
    },

    //Обновить информацию о новых уведомлениях
    async updateNewNotifications({ commit }, { avatars, count }){
      commit('SET_NOTIFICATIONS_COUNT', count);
      commit('ADD_USER_AVATAR_TO_LIST', avatars);
    }
  },

  mutations: {
    //Переключить видимость попапа
    TOGGLE_VISIBILITY_STATUS(state, status) { 
      state.isOpenPopup = status; 
    },

    //Добавить Avatar пользователя в список отображаемых
    ADD_USER_AVATAR_TO_LIST(state, data) { 
      state.avatarList = data; 
    },
    
    //Установить количество уведомлений
    SET_NOTIFICATIONS_COUNT(state, count) {
      state.notificationsCount = count;
    },

    //Обозначить, что виджет готов к отображению
    SET_NOTIFICATIONS_READY_FLAG(state){
      state.isReady = true;
    },

    //Очистить уведомления
    RESET_NOTIFICATIONS(state) {
      state.list = [];
      state.currentPage = 1;
      state.hasNextPage = true;
    },

    //Добавить новые уведомления
    ADD_NOTIFICATIONS(state, notifications) {
      state.list = [...state.list, ...notifications];
    },
    
    //Обозначить, что список готов к отображению
    SET_READY_LIST_STATE(state) {
      state.isListReady = true;
    },

    //Обозначить процесс загрузки сл. страницы данных уведомлений
    SET_LOADING_NEXT_PAGE_STATE(state, isLoading) {
      state.loadingNextPage = isLoading;
    },

    //Отметить данные для пагинации
    SET_PAGINATION(state, { currentPage, hasNextPage }) {
      state.currentPage = currentPage;
      state.hasNextPage = hasNextPage;
    },

    //Отметить все уведомления как прочитанные
    MARK_ALL_NOTIFICATIONS_AS_READ(state){
      state.list.forEach(item => item.is_read_modal_window = true);
      state.notificationsCount = 0;
    },

    //Отметить выбранные уведомления как прочитанные
    MARK_NOTIFICATION_AS_READ(state, notificationId) {
      const notification = state.list.find(n => n.id === notificationId);
      if (notification) {
        notification.is_read_modal_window = true;
        if(state.notificationsCount > 0) state.notificationsCount--;
      }
    }
  },

  getters: {
   
  }
}

export default Notifications;